import { isActive } from '@tiptap/core';

const isExtEnableAndActive = (editor, name, state = null) => {
  const { schema } = editor;
  const markType = schema.marks[name];
  const nodeType = schema.nodes[name];

  const resolvedName = markType?.name ?? nodeType?.name;
  if (!resolvedName) return false;

  return state ? isActive(state, resolvedName) : editor.isActive(resolvedName);
};

export default isExtEnableAndActive;
